import React from 'react';
import { DataList, createInitialFilters } from 'commons-ui';

import { LIST_ENTITY_NAMES } from 'constant';
import useDashboardActions from 'pages/dashboard/useDashboardActions';

import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import useService from '../../utils/useService';
import { activeFilter, columnConfigs } from './listConfig';

const OfferList: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const actions = getActionList();
	const { getTDSOfferData, segmentLabelList, mapValueList } = useService();
	if (actions?.addAction) {
		actions.addAction.segmentList = segmentLabelList;
		actions.addAction.mapValues = mapValueList;
	}
	actions.rowActions[1].segmentList = segmentLabelList;
	actions.rowActions[1].mapValues = mapValueList;
	actions.rowActions[0].segmentList = segmentLabelList;
	return (
		<DataList
			fetchData={getTDSOfferData}
			columnConfigs={columnConfigs}
			getActionHandler={getActionHandler}
			actions={actions}
			entity={LIST_ENTITY_NAMES.TDS_OFFERS}
			initialFilters={createInitialFilters(activeFilter)}
			initialSortDirection='ASC'
			initialSortIndex={1}
		/>
	);
};

export default OfferList;
